@if (loading()) {
  <span class="msa-btn__spinner" aria-hidden="true"></span>
}
@if (icon() && iconPosition() !== 'right') {
  <span class="msa-btn__icon">{{ icon() }}</span>
}
@if (iconSvg() && iconPosition() !== 'right') {
  <lib-icon [svg]="iconSvg()!" size="sm" />
}
@if (label()) {
  <span class="msa-btn__label">{{ label() }}</span>
}
<ng-content></ng-content>
@if (icon() && iconPosition() === 'right') {
  <span class="msa-btn__icon">{{ icon() }}</span>
}
@if (iconSvg() && iconPosition() === 'right') {
  <lib-icon [svg]="iconSvg()!" size="sm" />
}
@if (dropdown()) {
  <span class="msa-btn__dropdown">▾</span>
}
